import { useGrid } from '@Components/Grid/context';
import { TableResizeProvider } from '@Components/tableResize/context';
import { useInicializeTableResize } from '@Components/tableResize/hooks';

import DefaultTableBody from './Body';
import DefaultTableHeader from './Header';
import TableWrapper from './Wrapper';
import { TableProvider } from './context';

export default function DefaultTable() {
  const { definitions: { enableTableResize = true } } = useGrid()

  return <TableProvider>
    {!enableTableResize ? <DefaultTableContent /> : <>
      <TableResizeProvider>
        <DefaultTableResizeContent />
      </TableResizeProvider>
    </>}
  </TableProvider>
}

function DefaultTableResizeContent() {
  const { columns } = useGrid()
  const { hadResized, onResize } = useInicializeTableResize({ columns })

  return <TableWrapper hadResized={hadResized}>
    <DefaultTableHeader onResize={onResize} />
    <DefaultTableBody />
  </TableWrapper>
}

function DefaultTableContent() {
  return <TableWrapper hadResized={false}>
    <DefaultTableHeader />
    <DefaultTableBody />
  </TableWrapper>
}
